// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoWrapper_container__1w2xf","videoFrame":"VideoWrapper_videoFrame__2Y3HX"};